<div class="detail-info" style="width: 100%">
  <ng-container>
    <div class="left-col">
      <div style="display: flex; justify-content: center">
        <img
          *ngIf="locationState?.locationImgUrl !== ''"
          class="detail-info__modal-img"
          [src]="currentMainImageState?.locationImgUrl || noImagePath"
          alt=""
        />
      </div>
    </div>
  </ng-container>
  <div class="detail-info__modal-text right-col">
    <div class="center-content">
      <div>
        <p class="spot-info-font" *ngIf="hasTargetLangAddress && locationState?.address">
          <img src="assets/icon/shared/spot-small-icon-black.svg"  alt=""/>
          <span> {{ locationState?.address }}</span>
        </p>
        <p class="spot-info-font" *ngIf="!hasTargetLangAddress && locationState?.translation[useLang]?.address">
          <img src="assets/icon/shared/spot-small-icon-black.svg"  alt=""/>
          <span> {{ locationState?.translation[useLang]?.address }}</span>
        </p>

        <a *ngIf="locationState?.tel" class="spot-info-font" [href]="'tel:' + locationState?.tel">
          <img src="assets/icon/shared/tel-small-icon-black.svg" alt="Icon" /> {{ locationState?.tel }}</a
        >
      </div>
    </div>
    <div class="sub-image-container">
      <div *ngFor="let subImageState of subImageStates">
        <img [src]="subImageState.locationImgUrl || noImagePath" alt="Sub Image" (click)="changeMainImage(subImageState)" />
      </div>
    </div>
  </div>
</div>

<ion-text class="ion-no-padding detail-info__modal-text">
  <div id="spot-detail-scroll-content" class="spot-detail-scroll-content">
    <ng-container>
      <ng-container *ngIf="hasTargetLangDetail; else translatedSpotDetail">
        <ng-container *ngIf="locationState?.detail">
          <span style="white-space: pre-line">{{ locationState.detail }}</span>
          <br />
        </ng-container>
      </ng-container>
      <ng-template #translatedSpotDetail>
        <span style="white-space: pre-line">{{ locationState?.translation[useLang]?.detail }}</span>
        <br />
      </ng-template>
    </ng-container>
  </div>
</ion-text>
